import { useNavigate } from "react-router-dom";
import { IITD_TITLE } from "../../utils/constants";
import BackButton from "../../components/back_button";

export default function RegistrationType() {
  const navigate = useNavigate();
  const tabList = [
    // {
    //   key: "school",
    //   text1: "Register your School",
    //   text2:
    //     "For school principal / school admin (One time school registration required)",
    // },
    // {
    //   key: "teacher",
    //   text1: "Register as a School Teacher",
    //   text2: "After school registration, unique school code required.",
    // },
    // {
    //   key: "college",
    //   text1: "Register your College",
    //   text2:
    //     "For college principal / college admin (One-time college registration required).",
    // },
    // {
    //   key: "college_professor",
    //   text1: "Register as a College Professor",
    //   text2: "After college registration, unique college code required.",
    // },
    { key: "industry", text1: "Register as a Industry Visitor", text2: "" },
    {
      key: "GOVERNMENT_OFFICER",
      text1: "Register as a Government Officer",
      text2: "",
    },

    // { key: "visitor", text1: "Register as a Visitor", text2: "" },
    { key: "sponser", text1: "Register as a Sponsor", text2: "" },
  ];

  return (
    <div className="form-div">
      <div className="left-div">
        <BackButton />
        <h1>{IITD_TITLE}</h1>
        <div className="custom-tab">
          {tabList.map((tabs) => (
            <div
              className="tab"
              onClick={() => {
                navigate("/registration", { state: tabs.key });
              }}
            >
              <h5>{tabs.text1}</h5>
              <h6>{tabs.text2}</h6>
            </div>
          ))}
        </div>
      </div>
      <div className="right-div">
        <img
          className="side-image"
          src="image/iitd-img.png"
          alt="IIT-Delhi"
        ></img>
      </div>
    </div>
  );
}
